import { ENV } from "../app/interfaces/interfaces";

export const environment: ENV = {
    production: false,
    apiUrl: 'https://demo.gateway.test.todotix.net/', //Test
    apiUrlNormal: 'https://demo.gateway.test.todotix.net/', //Test
    vaucherUrl: 'https://demo.vouchers.test.todotix.net/',
    type: 'demo',

    version: null,                //para agragar la version string | null ejem: 0.0.0
    darkMode: true,               //activa icon modo oscuro boolen | null
    changesPassword: true,        // habiliatar en micuenta cambiar contrasena
    twoFA: true                   // habiliatar en micuenta 2fa
};
